
import { CloseOutlined, DownOutlined, HomeOutlined, MailOutlined, PhoneOutlined, PlusSquareOutlined } from "@ant-design/icons";
import "../stylestabs.scss";

import { Button, ConfigProvider, DatePicker, Flex, Form, Input, Select, SelectProps, Tag } from "antd";
import { avatar, icon_delelte, icon_document } from "../../../../components/ExportImgFigma";
import { fommatSelectOption, fommatSelectOptionData, fommatSelectOptionListType } from "../../../../until";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import * as selectOptionsApi from "../../../../api/selectOptions/selectOptionsApi";
import { ICustomerDetail_V4 } from "../../../../api/customer/customerApi";
import UploadImage from "../../../../components/Upload/UploadImage";
import { URL_CUSTOMER } from "../../../../env";
import viVN from 'antd/locale/vi_VN';
import '../../styles.scss'
import { CustomerType, dataCarCustomerTypes, dataGender, dataStatusMarital, dataTypeCustomer, dataTypeCustomer2, dataTypeDocument } from "../../../../services/data";
import { OptionType } from "../../../Customers/Component/AddCustomer/Component/PersonalInformationUpdate";
import { getListCustomerTypes, ICustomerTypes } from "../../../../api/selectOption/selectOptionsApi";
import dayjs from "dayjs";
import useToast from "../../../../hook/useToast";
import useThrottle from "../../../../hook/useThrottle";
import { ListFieldCustomer } from "../../../../api/Customer_V2/customerApi_V2";
import { updateRelativeCustomer_V4 } from "../../../../api/relatives/relativesApi";
import useDebounce from "../../../../hook/useDebounce";


type TagRender = SelectProps['tagRender'];

const options: SelectProps['options'] = [
  { value: 'gold' },
  { value: 'lime' },
  { value: 'green' },
  { value: 'cyan' },
];


interface CustomerFilterSearch {
  searchBusinessFieldId?: string;
  searchProvince?: string;
  searchDistrict?: string
  searchGroup?: string
  searchProfessionId?: string
  searchHobby?: string
}

const { TextArea } = Input;
interface Prop {
  isEdit: boolean
  sLTypePhone?: selectOptionsApi.ISelectOption[]
  infoCustomer?: ICustomerDetail_V4;
  infoCustomerByFields?: ListFieldCustomer[]
  resultFormSubmit?: (iSsuccess: boolean, message?: string) => void
  setIsEditing: (e: boolean) => void
}

const EditInfomation: React.FC<Prop> = ({
  isEdit,
  sLTypePhone, infoCustomer, infoCustomerByFields,
  resultFormSubmit, setIsEditing
}) => {
  const formRef: any = useRef(null)
  const [form] = Form.useForm();
  const pushToast = useToast();
  const businessCheck = Form.useWatch("businessCheck", form);

  const { Individual: CaNhan } = CustomerType

  const [isOpenTagCustomerType, setIsOpenTagCustomerType] = useState(false);

  const [sLProfession, setSLProfession] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLHobby, setSLHobby] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLGroup, setSLGroup] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLProvice, setSLProvice] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLDistrict_V2, setSLDistrict_V2] = useState<Record<number, OptionType[]>>({});
  const [sLBusinessField, setSLBusinessField] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLCustomerType, setSLCustomerType] = useState<ICustomerTypes[]>([])
  const [searchFilter, setSearchFilter] = useState<CustomerFilterSearch>()

  const [uploadedFile, setUploadedFile] = useState<File | null>(null);


  const gSLCustomerTypes = async () => {
    const result = await getListCustomerTypes();
    if (result?.status) {
      setSLCustomerType(result.data)
    }
  }

  const gSLProfession = useDebounce(async () => {
    const result = await selectOptionsApi.getCLProfession(searchFilter?.searchProfessionId);
    if (result?.status) {
      setSLProfession(fommatSelectOption(result.data))
    }
  }, 500)
  const gBusinessField = useDebounce(async () => {
    const result = await selectOptionsApi.getBusinessField(searchFilter?.searchBusinessFieldId);
    if (result?.status) {
      setSLBusinessField(fommatSelectOption(result.data))
    }
  }, 500)
  const gSLHobby = useDebounce(async () => {
    const result = await selectOptionsApi.getListHobby(searchFilter?.searchHobby);
    if (result?.status) {
      setSLHobby(fommatSelectOption(result.data))
    }
  }, 500)

  const gSLGroup = useDebounce(async () => {
    const result = await selectOptionsApi.getListGroup(searchFilter?.searchGroup);
    if (result?.status) {
      setSLGroup(fommatSelectOption(result.data))
    }
  }, 500)

  const gSLProvice = useDebounce(async () => {
    const result = await selectOptionsApi.getListProvince(searchFilter?.searchProvince);
    if (result?.status) {
      setSLProvice(fommatSelectOption(result.data))
    }
  }, 500)


  // New => fix địa chỉ khi []
  // helper ngắn
  const sanitizeId = (v: any) => {
    if (v === null || v === undefined) return undefined;
    if (v === 0 || v === '0' || v === '') return undefined;
    const n = Number(v);
    return Number.isNaN(n) ? undefined : n;
  };

  // load districts (gọn)
  const gSLDistrict_V2 = async (
    provinceId: number,
    index: number,
    search?: string
  ) => {
    const result = await selectOptionsApi.getListDistrict(
      Number(provinceId),
      search
    );
    if (result?.status) {
      setSLDistrict_V2((prev) => ({
        ...prev,
        [index]: fommatSelectOption(result.data),
      }));
    } else {
      pushToast(result?.message, "error");
    }
  };
  // const gSLDistrict_V2 = useDebounce(async (provinceId: number | string | undefined, index: number) => {
  //   const pid = sanitizeId(provinceId);
  //   if (!pid) {
  //     setSLDistrict_V2(prev => ({ ...prev, [index]: [] }));
  //     return;
  //   }
  //   const res = await selectOptionsApi.getListDistrict(pid);
  //   setSLDistrict_V2(prev => ({ ...prev, [index]: fommatSelectOption(res?.data || []) }));
  // }, 500)

  // onChange province (gọn)
  const onChangeProvince_V2 = (value: any, index: number) => {
    form.setFieldValue(['address', index, 'districtId'], undefined);
    const pid = sanitizeId(value);
    if (!pid) {
      setSLDistrict_V2(prev => ({ ...prev, [index]: [] }));
      return;
    }
    gSLDistrict_V2(pid, index);
  };


  const handleSearchDistrict = (value: string, i: number) => {
    const provinceId = form.getFieldValue(["address", i, "provinceId"]);
    if (provinceId)
      gSLDistrict_V2(provinceId, i, value)
  };

  // End new

  const handleSetFileFromUrl = (url: string) => {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const file = new File([blob], 'image.png', { type: blob.type });
        setUploadedFile(file);
        form.setFieldsValue({ image: file });
      });
  };

  const handleFileChange = (file: File) => {
    setUploadedFile(file);
  };

  const getEditClass = (code: string) => {
    var checkEdit = infoCustomerByFields?.some(f => f.fieldCode === code && f.edit);
    var checkView = infoCustomerByFields?.some(f => f.fieldCode === code && f.view);
    if (!checkView) return 'd-none'
    if (!checkEdit && checkView) return 'disabled'
    if (checkEdit && checkView) return ''
  }


  const onChangeProvice_V2 = (value?: number, i?: number) => {
    if (!value) {
      setSearchFilter({ ...searchFilter, searchProvince: '' })
      setSLDistrict_V2((prev) => ({ ...prev, [Number(i)]: [] }));
    } else {
      // setProvice(value);
      gSLDistrict_V2(value, Number(i));
    }
  };


  // FORM SUBMIT
  const onFormSubmit = useThrottle(async (values: any) => {

    const {
      businessCheck, type, usernameList, CCCD, passport, phone, email,
      contactMethod, listTypes, listTypeCar, hobbyId, groupCustomerId,
      description, taxCode, address, birthday, professionId,
      foundingDate, businessFieldId, gender, statusMarital
    } = values;

    const validBirthday = birthday ? birthday?.format('YYYY/MM/DD') : undefined
    const validEmails = email.map((item: any) => item?.email).filter((email: any) => typeof email === "string" && email.trim() !== "");
    const validAddresses = address.filter((item: any) =>
      (item.provinceId !== null && item.provinceId !== undefined) ||
      (item.address && item.address.trim() !== "")
    );
    const validFoundingDate = foundingDate ? foundingDate?.format('YYYY/MM/DD') : undefined

    // Kiểm tra số điện thoại trùng lặp
    const phoneNumbers = phone?.map((item: any) => item.phone);
    const uniqueNumbers = new Set(phoneNumbers);

    if (phoneNumbers.length !== uniqueNumbers.size) {
      pushToast("Các số điện thoại không được trùng lặp", 'error')
      return; // Dừng xử lý nếu phát hiện trùng lặp
    }


    const result = await updateRelativeCustomer_V4(
      Number(infoCustomer?.id), businessCheck, usernameList, phone,
      type, CCCD, gender,
      statusMarital, listTypes, professionId, validBirthday,
      validEmails, contactMethod, listTypeCar, validAddresses,
      uploadedFile, groupCustomerId, hobbyId,
      undefined, undefined, description, taxCode,
      validFoundingDate, undefined,
    )
    if (result?.status) {
      resultFormSubmit?.(true, result?.message)
    } else {
      resultFormSubmit?.(false, result?.message)
    }
  }, 2000)

  useEffect(() => {
    gSLGroup()
  }, [searchFilter?.searchGroup])

  useEffect(() => {
    gSLProvice()
  }, [searchFilter?.searchProvince])

  useEffect(() => {
    gBusinessField()
  }, [searchFilter?.searchBusinessFieldId])

  useEffect(() => {
    gSLProfession()
  }, [searchFilter?.searchProfessionId])

  useEffect(() => {
    gSLHobby()
  }, [searchFilter?.searchHobby])


  useEffect(() => {
    if (infoCustomer && isEdit) {
      if (!sLCustomerType.length)
        gSLCustomerTypes()
      if (!sLProfession?.length)
        gSLProfession();
      if (!sLHobby?.length)
        gSLHobby();
      if (!sLGroup?.length)
        gSLGroup();
      if (!sLProvice?.length)
        gSLProvice();
      if (!sLBusinessField?.length)
        gBusinessField();
    }
  }, [infoCustomer]);


  useEffect(() => {
    if (infoCustomer && isEdit) {

      const {
        id, address, birthday, email, gender, groupCustomer, hobby, phone,
        profession, businessField, statusMarital, userName,
        image, CCCD, taxCode, foundingDate, description, businessCheck, customerType, type,
        contactMethod, carLine, identityType
      } = infoCustomer

      const validContactMethod = contactMethod?.map((item) => item.id) ?? []
      const validEmail = email;
      const validCustomerType = customerType?.map((item) => item.id) ?? []
      const validBirthday = birthday ? dayjs(birthday, 'YYYY/MM/DD') : null
      const validFoundingDate = foundingDate ? dayjs(foundingDate, 'YYYY/MM/DD') : null
      const validCarLine = carLine?.map((item) => item.id) ?? []
      const validHobby = hobby?.map((item) => item.id) ?? []
      const validGroupCustomerId = groupCustomer?.map((item) => item.id) ?? []
      form.setFieldsValue({
        businessCheck: businessCheck,
        type: type,
        usernameList: userName,
        gender,
        statusMarital: statusMarital,
        birthday: validBirthday,
        foundingDate: validFoundingDate,
        CCCD: CCCD,
        taxCode: businessCheck ? taxCode : null,
        professionId: profession?.id,
        businessFieldId: businessField?.id,
        phone: phone,
        email: validEmail,
        contactMethod: validContactMethod,
        listTypes: validCustomerType,
        carLine: validCarLine,
        hobbyId: validHobby,
        groupCustomerId: validGroupCustomerId,
        description: description,
        address: address,
      });

      address.map((item, i) => {
        gSLDistrict_V2(item.provinceId, i)
      })

    } else {
      form.resetFields()
    }
  }, [infoCustomer]);

  // new
  useEffect(() => {
    if (!infoCustomer || !isEdit) {
      form.resetFields();
      form.setFieldsValue({ address: [{}] });
      return;
    }

    const { address = [], birthday, foundingDate, ...rest } = infoCustomer;

    const sanitizeId = (v: any) => {
      if (v === null || v === undefined) return undefined;
      if (v === 0 || v === '0' || v === '') return undefined;
      const n = Number(v);
      return Number.isNaN(n) ? undefined : n;
    };

    const validAddresses = (address.length ? address : [{}]).map((a: any) => ({
      ...a,
      provinceId: sanitizeId(a.provinceId),
      districtId: sanitizeId(a.districtId),
    }));

    // Convert ngày về dayjs hoặc undefined (để DatePicker không bị lỗi)
    const parseDate = (v: any) => (v ? dayjs(v, 'YYYY/MM/DD') : undefined);

    form.setFieldsValue({
      ...rest,
      birthday: parseDate(birthday),
      foundingDate: parseDate(foundingDate),
      address: validAddresses,
    });

    // load district cho những address có provinceId
    validAddresses.forEach((addr: any, i: number) => {
      if (addr.provinceId) gSLDistrict_V2(addr.provinceId, i);
      else setSLDistrict_V2(prev => ({ ...prev, [i]: [] }));
    });
  }, [infoCustomer, isEdit]);
  // let a = infoCustomerByFields?.filter(item => item.fieldCode === 'cus_group_name')
  // console.log(infoCustomerByFields?.forEach(item => item.fieldCode === "cus_group_name"));

  return (
    <>
      <div className="edit-section mt-3 space-y-3 custom-select-multiple custom-page-css">
        <div className="settings-icon top-right">
          <div className="flex gap-2 items-center">
            <Button
              type="primary"
              size="small"
              onClick={() => formRef?.current.submit()}
            >
              Lưu
            </Button>
            <div
              className="w-6 h-6 d-flex justify-center align-center cursor-pointer border-D9D9D9 rounded-2 color-icon-setting"
              onClick={() => setIsEditing(false)}
            >
              <CloseOutlined />
            </div>
          </div>
        </div>
        {/* <label className="font-medium fs-14 custom-mb font-medium">Thông tin cá nhân</label> */}
        {/* Form Số điện thoại */}
        <Form
          ref={formRef}
          form={form}
          className="pt-8"
          layout="vertical"
          onFinish={onFormSubmit}
        >
          {/* Form Số điện thoại */}
          <div className="profile-header">
            <div className="avatar">
              <UploadImage
                imgUrl={`${URL_CUSTOMER}${infoCustomer?.image}`}
                onChange={handleFileChange}
              />
            </div>
          </div>
          <div className="information-tab__content-left mt-2 gap-1">
            <div className="d-flex justify-between w-full  items-center">
              <span className="font-medium fs-14 text-344054">{businessCheck === CaNhan ? 'Thông tin cá nhân' : 'Thông tin doanh nghiệp'}</span>
            </div>

            <div className={`${getEditClass('cus_type_name')} custom-page-css flex flex-col`}>
              <Form.Item
                label={<span className="custom-page-css text-sm font-regular text-344054">Loại khách hàng</span>}
                layout="vertical"
                name="businessCheck"
                className="m-none-form-item text-explan text-label"
                rules={[
                  { required: true, message: 'Vui lòng chọn loại khách hàng' }
                ]}
              >
                <Select
                  allowClear
                  options={dataTypeCustomer}
                  className="custom-page-css border rounded overflow-hidden"
                />
              </Form.Item>
            </div>

            <div className={`${getEditClass('cus_scope')} custom-page-css flex flex-col`}>
              <Form.Item
                label={<span className="custom-page-css text-sm font-regular text-344054">Chi tiết loại khách hàng</span>}
                layout="vertical"
                name="type"
                className="m-none-form-item text-explan text-label"
              >
                <Select
                  allowClear
                  options={dataTypeCustomer2}
                  className="custom-page-css border rounded overflow-hidden"

                />
              </Form.Item>
            </div>
            {/* Họ và tên */}
            <div className={`${getEditClass("cus_name")} custom-page-css flex flex-col`}>
              <label className="custom-page-css text-sm font-regular text-344054">
                Họ và tên
              </label>

              <Form.List
                name="usernameList"
                initialValue={[{ username: "", isPrimary: 1 }]} // dòng đầu tiên là "chính"
              >
                {(fields, { add, remove }) => (
                  <Flex vertical>
                    {fields.map((field, index) => (
                      <div key={field.key} className="d-flex gap-1 mb-1 align-center">
                        <Form.Item
                          className="w-full"
                          name={[field.name, "username"]}
                          rules={[
                            { required: true, message: `Vui lòng nhập ${!infoCustomer?.businessCheck ? "Họ và tên" : "Tên công ty"}` }
                          ]}
                        >
                          <Input
                            placeholder={`${!infoCustomer?.businessCheck ? " Họ và tên" : "Tên công ty"}`}
                            // className="border-F2F4F7 text-sm rounded font-regular"
                            className="custom-input-css custom-page-css border"

                          />
                        </Form.Item>

                        {/* Ẩn trường isPrimary nhưng vẫn lưu giá trị */}
                        <Form.Item
                          name={[field.name, "isPrimary"]}
                          initialValue={index === 0 ? 1 : 0}
                          hidden
                        >
                          <Input type="hidden" />
                        </Form.Item>

                        <img
                          hidden={fields.length <= 1 || index === 0} // Không cho xóa dòng đầu tiên
                          src={icon_delelte}
                          alt=""
                          className="rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"
                          onClick={() => remove(field.name)}
                        />
                      </div>
                    ))}

                    <div
                      className="d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit"
                      onClick={() => add({ username: "", isPrimary: 0 })}
                    >
                      <PlusSquareOutlined className="fs-14" />
                      <span className="fs-14">{!infoCustomer?.businessCheck ? "Thêm họ và tên" : "Thêm tên công ty"}</span>
                    </div>
                  </Flex>
                )}
              </Form.List>
            </div>


            {
              businessCheck === CaNhan && (
                <>
                  <div className={`${getEditClass('cus_gender_name')} custom-page-css flex flex-col`}>
                    <Form.Item
                      label={<span className="custom-page-css text-sm font-regular text-344054">Giới tính</span>}
                      layout="vertical"
                      name="gender"
                      className="m-none-form-item text-explan text-label"
                    >
                      <Select
                        allowClear
                        options={fommatSelectOptionData(dataGender)}
                        className="custom-page-css border rounded overflow-hidden"

                      />

                    </Form.Item>
                  </div>
                  <div className={`${getEditClass('cus_marital_status')} custom-page-css flex flex-col`}>
                    <Form.Item
                      label={<span className="custom-page-css text-sm font-regular text-344054">Tình trạng hôn nhân</span>}
                      layout="vertical"
                      name="statusMarital"
                      className="m-none-form-item text-explan text-label"
                    >
                      <Select
                        allowClear
                        options={fommatSelectOptionData(dataStatusMarital)}
                        className="custom-page-css border rounded overflow-hidden"
                      />
                    </Form.Item>
                  </div>

                  <div className={`${getEditClass('cus_birth_day')} custom-page-css flex flex-col`}>
                    <Form.Item
                      label={<span className="custom-page-css text-sm font-regular text-344054">Ngày sinh</span>}
                      layout="vertical"
                      name="birthday"
                      className="m-none-form-item text-explan text-label"
                    >
                      {/* <ConfigProvider locale={viVN}> */}
                      <DatePicker
                        placeholder='Ngày sinh'
                        className='custom-input-date w-full '
                        popupClassName='rs-date-picker-dropdown'
                        format='DD/MM/YYYY'
                        disabledDate={(current) => current && current > dayjs().endOf('day')}
                      />
                      {/* </ConfigProvider> */}
                    </Form.Item>
                  </div>


                  {/* CCCD */}
                  <div className={`${getEditClass('cus_dms_id_card_no')}`}>
                    <label className="custom-page-css text-sm font-regular text-344054">
                      CCCD/ Hộ chiếu
                    </label>
                    <Form.List
                      name="CCCD"
                      initialValue={[{ name: "", identityType: null, isPrimary: 1 }]} // Thêm isPrimary mặc định
                    >
                      {(fields, { add, remove }) => (
                        <Flex vertical>
                          {fields.map((field) => (
                            <div key={field.key} className="d-flex gap-1 mb-1">
                              <Form.Item noStyle shouldUpdate>
                                {({ getFieldValue }) => {
                                  const typeDocument = getFieldValue(['CCCD', field.name, "identityType"]);
                                  const isDisabled = !typeDocument && typeDocument !== 0; // 0 là CCCD
                                  return (
                                    <Form.Item
                                      className="w-full"
                                      name={[field.name, "name"]}
                                      rules={[
                                        { required: true, message: "Vui lòng nhập giấy tờ" },
                                        ({ getFieldValue }) => ({
                                          validator(_, value) {
                                            const currentTypeDoc = getFieldValue(['CCCD', field.name, "identityType"]);

                                            // Kiểm tra đã chọn loại giấy tờ chưa
                                            if (currentTypeDoc === undefined || currentTypeDoc === null) {
                                              return Promise.reject(new Error("Vui lòng chọn loại giấy tờ trước"));
                                            }

                                            // Validate theo loại giấy tờ
                                            if (currentTypeDoc === 0 && !/^\d{12}$/.test(value)) {
                                              return Promise.reject(new Error("CCCD phải gồm đúng 12 chữ số"));
                                            }

                                            const passport = value?.toUpperCase().trim();

                                            if (currentTypeDoc === 1 && !/^[A-Z0-9]{6,9}$/.test(passport)) {
                                              return Promise.reject(
                                                new Error(
                                                  "Số hộ chiếu không hợp lệ (6–9 ký tự chữ hoặc số)"
                                                )
                                              );
                                            }


                                            return Promise.resolve();
                                          },
                                        }),
                                      ]}
                                    >
                                      <Input
                                        placeholder={typeDocument ? 'Hộ chiếu' : 'CCCD'}
                                        disabled={isDisabled}
                                        className="custom-input-css custom-page-css border"
                                      />
                                    </Form.Item>
                                  );
                                }}
                              </Form.Item>

                              <Form.Item
                                name={[field.name, "identityType"]}
                                rules={[{ required: true, message: "Vui lòng chọn loại giấy tờ" }]}
                              >
                                <Select
                                  options={dataTypeDocument}
                                  placeholder="Loại giấy tờ"
                                  className="custom-page-css border rounded overflow-hidden"

                                  onChange={(val) => {
                                    // Lấy toàn bộ giá trị hiện tại
                                    const currentValues = form.getFieldValue("CCCD") || [];

                                    if (currentValues[field.name]) {
                                      // Cập nhật identityType cho phần tử hiện tại
                                      currentValues[field.name].identityType = val;

                                      // Reset tất cả isPrimary về 0
                                      currentValues.forEach((item: any, index: number) => {
                                        item.isPrimary = 0;
                                      });

                                      // Set phần tử đầu tiên (index 0) là isPrimary = 1
                                      if (currentValues[0]) {
                                        currentValues[0].isPrimary = 1;
                                      }

                                      // Cập nhật lại form
                                      form.setFieldsValue({ CCCD: currentValues });
                                    }
                                  }}
                                />
                              </Form.Item>

                              <img
                                hidden={fields.length <= 1}
                                src={icon_delelte}
                                alt=""
                                className="rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"
                                onClick={() => remove(field.name)}
                              />
                            </div>
                          ))}

                          <div
                            className="d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit "
                            onClick={() => add({ name: "", identityType: null, isPrimary: 1 })}
                          >
                            <PlusSquareOutlined className="fs-14" />
                            <span className="fs-14">Thêm loại giấy tờ mới</span>
                          </div>
                        </Flex>
                      )}
                    </Form.List>
                  </div>
                  {/* nghề nghiệp */}
                  {/* <div className={`${getEditClass('cus_career_name')} custom-page-css flex flex-col`}>
                    <Form.Item
                      label={<span className="custom-page-css text-sm font-regular text-344054">Nghề nghiệp</span>}
                      layout="vertical"
                      name="professionId"
                      className="m-none-form-item text-explan text-label"
                    >
                      <Select
                        allowClear
                        options={sLProfession}
                        className="custom-page-css border rounded overflow-hidden"
                        showSearch
                        filterOption={false}
                        onSearch={(value) => setSearchFilter({ ...searchFilter, searchProfessionId: value })}
                        onBlur={() => {
                          // Giữ lại search value khi blur, hoặc có thể reset nếu muốn
                          setSearchFilter({ ...searchFilter, searchProfessionId: '' }); // Nếu muốn reset khi blur
                        }}
                      />
                    </Form.Item>
                  </div> */}
                </>
              )
            }
            {
              businessCheck !== CaNhan && (
                <>
                  <div className={`${getEditClass('cus_founding_date')} custom-page-css flex flex-col`}>
                    <Form.Item
                      label={<span className="custom-page-css text-sm font-regular text-344054">Ngày thành lập</span>}
                      layout="vertical"
                      name="foundingDate"
                      className="m-none-form-item text-explan text-label"
                    >
                      {/* <ConfigProvider locale={viVN}> */}
                      <DatePicker
                        placeholder='Năm thành lập'
                        className='custom-input-date w-full '
                        popupClassName='rs-date-picker-dropdown'
                        format='DD/MM/YYYY'
                        disabledDate={(current) => current && current > dayjs().endOf('day')}
                      />
                      {/* </ConfigProvider> */}

                    </Form.Item>
                  </div>

                  <div className={`${getEditClass('cus_tax_reg_no_dms')} custom-page-css flex flex-col`}>
                    <Form.Item
                      label={<span className="custom-page-css text-sm font-regular text-344054">Mã số thuế</span>}
                      layout="vertical"
                      name="taxCode"
                      className="m-none-form-item text-explan text-label"
                      rules={[{ required: true, message: "Vui nhập mã số thuế!" }]}
                    >
                      <Input
                        placeholder="Mã số thuế"
                        className=" custom-input-css custom-page-css  border "
                      />
                    </Form.Item>
                  </div>

                  {/* <div className={`${getEditClass('cus_career_name')} custom-page-css flex flex-col`}>
                    <Form.Item
                      label={<span className="custom-page-css text-sm font-regular text-344054">Ngành nghề kinh doanh</span>}
                      layout="vertical"
                      name="businessFieldId"
                      className="m-none-form-item text-explan text-label"
                    >
                      <Select
                        allowClear
                        options={sLBusinessField}
                        className="custom-page-css border rounded overflow-hidden"
                        showSearch
                        filterOption={false}
                        onSearch={(value) => setSearchFilter({ ...searchFilter, searchBusinessFieldId: value })}
                        onBlur={() => {
                          // Giữ lại search value khi blur, hoặc có thể reset nếu muốn
                          setSearchFilter({ ...searchFilter, searchBusinessFieldId: '' }); // Nếu muốn reset khi blur
                        }}
                      />
                    </Form.Item>
                  </div> */}
                </>
              )
            }
            {/* nghề nghiệp */}
            <div className={`${getEditClass('cus_career_name')} custom-page-css flex flex-col`}>
              <Form.Item
                label={
                  <span className="custom-page-css text-sm font-regular text-344054">
                    {businessCheck === CaNhan ? "Nghề nghiệp" : "Ngành nghề kinh doanh"}
                  </span>
                }
                layout="vertical"
                name="professionId"
                className="m-none-form-item text-explan text-label"
              >
                <Select
                  allowClear
                  options={sLProfession}
                  className="custom-page-css border rounded overflow-hidden"
                  showSearch
                  filterOption={false}
                  onSearch={(value) => setSearchFilter({ ...searchFilter, searchProfessionId: value })}
                  onBlur={() => {
                    // Giữ lại search value khi blur, hoặc có thể reset nếu muốn
                    setSearchFilter({ ...searchFilter, searchProfessionId: '' }); // Nếu muốn reset khi blur
                  }}
                />
              </Form.Item>
            </div>

            {/* //Dùng Chung */}

            <div className={`${getEditClass('cus_tel')}`}>
              <label className="custom-page-css text-sm font-regular text-344054">
                Số điện thoại
              </label>
              <Form.List
                name="phone"
                initialValue={[{ phone: "", categoryPhoneId: null }]}
              >
                {(fields, { add, remove }) => (
                  <Flex vertical>
                    {fields.map((field) => (
                      <div key={field.key} className="d-flex gap-1 mb-1">
                        <Form.Item noStyle shouldUpdate>
                          {({ getFieldValue }) => {
                            const selected = getFieldValue(["phone", field.name, "categoryPhoneId",]);

                            return (
                              <Form.Item
                                className="w-full"
                                name={[field.name, "phone"]}
                                rules={[
                                  { required: true, message: "Vui lòng nhập số điện thoại" },
                                  () => ({
                                    validator(_, value) {
                                      if (!value) return Promise.resolve();
                                      const phoneType = getFieldValue(["phone", field.name, "categoryPhoneId",]);
                                      if (!phoneType) return Promise.resolve();

                                      const isHome = phoneType === 1;
                                      const isCompany = phoneType === 2;

                                      if (isHome && !/^0\d{9}$/.test(value)) {
                                        return Promise.reject(
                                          new Error(
                                            "Số điện thoại không hợp lệ (10 số, bắt đầu bằng 0)"
                                          )
                                        );
                                      }

                                      if (isCompany && !/^0\d{10,11}$/.test(value)) {
                                        return Promise.reject(
                                          new Error(
                                            "Số điện thoại không hợp lệ (11-12 số, bắt đầu bằng 0)"
                                          )
                                        );
                                      }

                                      return Promise.resolve();
                                    },
                                  }),
                                ]}
                              >
                                <Input
                                  prefix={<PhoneOutlined />}
                                  placeholder="Số điện thoại"
                                  className=" custom-input-css custom-page-css  border"
                                  type="tel"
                                  disabled={!selected}
                                />
                              </Form.Item>
                            );
                          }}
                        </Form.Item>

                        <Form.Item
                          name={[field.name, "categoryPhoneId"]}
                          rules={[{ required: true, message: "Vui lòng chọn loại điện thoại" }]}
                        >
                          <Select
                            options={sLTypePhone}
                            placeholder="Loại điện thoại"

                            className="custom-page-css border rounded overflow-hidden"

                            onChange={(val) => {
                              if (val == null) {
                                const curr = (form.getFieldValue("phone") ?? []).slice();
                                if (curr[field.name]) curr[field.name].phone = "";
                                form.setFieldsValue({ phone: curr });
                              }
                            }}
                          />
                        </Form.Item>

                        <img
                          hidden={fields.length <= 1}
                          src={icon_delelte}
                          alt=""
                          className="rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"
                          onClick={() => remove(field.name)}
                        />
                      </div>
                    ))}

                    <div
                      className="d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit "
                      onClick={() => add({ phone: "", categoryPhoneId: null })}
                    >
                      <PlusSquareOutlined className="fs-14" />
                      <span className="fs-14">Thêm số điện thoại mới</span>
                    </div>
                  </Flex>
                )}
              </Form.List>
            </div>

            <div className={`${getEditClass('cus_email')}`}>
              <label className="custom-page-css text-sm font-regular text-344054">Email</label>
              <Form.List name="email">
                {(fields, { add, remove }) => (
                  <div className="d-flex flex-column">
                    {fields.map((field, i) => (
                      <div key={field.key} className="d-flex gap-1 mb-1">
                        <Form.Item
                          name={[field.name, "email"]}
                          fieldKey={[i, "email"]}
                          className="m-none-form-item text-explan w-full"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng nhập email",
                            },
                            {
                              validator(_, value) {
                                if (!value) return Promise.resolve();

                                // Không cho khoảng trắng và Unicode
                                const asciiNoSpaceRegex = /^[\x21-\x7E]+$/;

                                if (!asciiNoSpaceRegex.test(value)) {
                                  return Promise.reject(
                                    new Error("Email không được chứa khoảng trắng hoặc ký tự Unicode")
                                  );
                                }

                                // Validate email: user@domain.tld
                                const emailRegex =
                                  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

                                if (!emailRegex.test(value)) {
                                  return Promise.reject(
                                    new Error("Email không đúng định dạng")
                                  );
                                }

                                return Promise.resolve();
                              },
                            }
                          ]}
                        >
                          <Input
                            placeholder="Mail"
                            className=" custom-input-css custom-page-css border"
                          />
                        </Form.Item>

                        <img
                          hidden={fields.length <= 1}
                          src={icon_delelte}
                          alt=""
                          className="rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"
                          onClick={() => remove(field.name)}
                        />
                      </div>
                    ))}

                    <div
                      className="d-flex align-center cursor-pointer text-1890FF pt-1 w-fit gap-1"
                      onClick={() => add({})}
                    >
                      <PlusSquareOutlined className="fs-14" />
                      <span className="fs-14">Thêm mail mới</span>
                    </div>
                  </div>
                )}
              </Form.List>
            </div>

            <div className={`${getEditClass('cus_lifecycle_status')} custom-page-css flex flex-col`}>
              <Form.Item
                label={<span className="custom-page-css text-sm font-regular text-344054">Phân loại khách hàng</span>}
                layout="vertical"
                name="listTypes"
                className="m-none-form-item text-explan text-label"
              >
                <Select
                  mode="multiple"
                  // tagRender={tagRender}
                  style={{ width: '100%' }}
                  options={fommatSelectOptionListType(sLCustomerType)}
                  className="custom-page-css border rounded overflow-hidden"

                />
              </Form.Item>
            </div>

            <div className={`${getEditClass('cus_interest')} custom-page-css flex flex-col`}>
              <Form.Item
                label={<span className="custom-page-css text-sm font-regular text-344054">Sở thích</span>}
                layout="vertical"
                name="hobbyId"
                className="m-none-form-item text-explan text-label"
              >
                <Select
                  className="custom-page-css border rounded overflow-hidden"
                  mode="multiple"
                  allowClear
                  options={sLHobby}
                  filterOption={false}
                  showSearch
                  onSearch={(value) => setSearchFilter({ ...searchFilter, searchHobby: value })}
                  onBlur={() => {
                    // Giữ lại search value khi blur, hoặc có thể reset nếu muốn
                    setSearchFilter({ ...searchFilter, searchHobby: '' }); // Nếu muốn reset khi blur
                  }}

                />
              </Form.Item>
            </div>

            <div className={`${getEditClass('cus_group_name')} custom-page-css flex flex-col`}>
              <Form.Item
                label={<span className="custom-page-css text-sm font-regular text-344054">Nhóm khách hàng</span>}
                layout="vertical"
                name="groupCustomerId"
                className="m-none-form-item text-explan text-label"
              >
                <Select
                  className="custom-page-css border rounded overflow-hidden"
                  mode="multiple"
                  allowClear
                  showSearch
                  options={sLGroup}

                  filterOption={false}
                  onSearch={(value) => setSearchFilter({ ...searchFilter, searchGroup: value })}
                  onBlur={() => setSearchFilter({ ...searchFilter, searchGroup: '' })}
                />

              </Form.Item>
            </div>

            <div className={`${getEditClass('cus_address')}`}>
              <label className="custom-page-css text-sm font-regular text-344054">Địa chỉ</label>
              <Form.List
                name="address"
              >
                {
                  (fields, { add, remove }) => (
                    <div className='d-flex flex-column gap-3 '>
                      {
                        fields.map((field, i) => (
                          <div
                            key={i}
                            className='d-flex flex-column gap-2 w-full'
                          >
                            <div className='d-flex flex-column gap-10-px w-full'>
                              <div key={field.key} className="d-flex gap-2 d-flex flex-column">
                                <Form.Item
                                  name={[field.name, "provinceId"]}
                                  fieldKey={[i, "provinceId"]}
                                  rules={[
                                    { required: false, message: 'Vui lòng chọn Tỉnh/Thành phố' }
                                  ]}
                                  className='w-full'
                                // initialValue={undefined}
                                >
                                  <Select
                                    placeholder="Tỉnh/Thành phố"
                                    className="custom-page-css border rounded overflow-hidden"
                                    showSearch
                                    allowClear
                                    filterOption={false}
                                    options={sLProvice}
                                    // onChange={(value) => {
                                    //   form.setFieldValue(['address', field.name, 'districtId'], undefined);
                                    //   onChangeProvince_V2(value, i);
                                    // }}
                                    onChange={(value) => {
                                      form.setFieldValue(
                                        ["address", field.name, "districtId"],
                                        undefined
                                      );
                                      onChangeProvice_V2(value, i);
                                    }}
                                    onSearch={(value) => setSearchFilter({ ...searchFilter, searchProvince: value })}
                                  />
                                </Form.Item>

                                <Form.Item
                                  name={[field.name, "districtId"]}
                                  fieldKey={[i, "districtId"]}
                                  rules={[
                                    { required: false, message: 'Vui lòng chọn phường/ xã' }
                                  ]}
                                  className='w-full'
                                >
                                  <Select
                                    className="custom-page-css border rounded overflow-hidden"
                                    showSearch
                                    allowClear
                                    filterOption={false}
                                    placeholder="Chọn phường/ xã"

                                    options={sLDistrict_V2[i] || []}
                                    onSearch={(value) => handleSearchDistrict(value, i)}
                                  />
                                </Form.Item>

                              </div>
                              <div className='d-flex gap-2'>
                                <Form.Item
                                  name={[field.name, "address"]}
                                  fieldKey={[i, "address"]}
                                  className='w-full'
                                >
                                  <Input
                                    placeholder="Địa chỉ (Không bắt buộc)"
                                    className='custom-input-css custom-page-css border'
                                  />
                                </Form.Item>
                                <img
                                  hidden={fields.length <= 1}
                                  src={icon_delelte}
                                  alt=""
                                  className="rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"

                                  onClick={() => {
                                    remove(i);

                                    // Sau khi xoá, cập nhật lại danh sách type
                                    const updatedAddresses = [...(form.getFieldValue("address") || [])];

                                    // Đảm bảo phần tử đầu tiên (nếu còn) có type = 1
                                    const newAddresses = updatedAddresses.map((item, idx) => ({
                                      ...item,
                                      type: idx === 0 ? 1 : 0
                                    }));

                                    form.setFieldsValue({ address: newAddresses });

                                    setSLDistrict_V2(prev => {
                                      const updated: Record<number, OptionType[]> = {};
                                      Object.keys(prev).forEach(keyStr => {
                                        const key = Number(keyStr);
                                        if (key < i) {
                                          updated[key] = prev[key];
                                        } else if (key > i) {
                                          updated[key - 1] = prev[key];
                                        }
                                      });
                                      return updated;
                                    });
                                  }}
                                />
                              </div>
                            </div>

                          </div>
                        ))
                      }
                      <div
                        className="d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit"
                        onClick={() => add({})}
                      >
                        <PlusSquareOutlined className="text-sm" />
                        <span className="text-sm">Thêm địa chỉ mới</span>
                      </div>
                    </div>
                  )
                }
              </Form.List>
            </div>

            <div className={`${getEditClass('cus_note')} custom-page-css flex flex-col`}>
              <Form.Item
                label={<span className="custom-page-css text-sm font-regular text-344054">Ghi chú</span>}
                layout="vertical"
                name="description"
                className="m-none-form-item text-explan text-label"
              >
                <TextArea rows={4} placeholder="Ghi chú" />
              </Form.Item>
            </div>
          </div >
        </Form >
      </div >
    </>
  )
}
export default React.memo(EditInfomation);